let isLoading = false;
let isLoaded = false;

export const loadGoogleMapsAPI = () => {
  return new Promise((resolve, reject) => {
    // Bereits geladen
    if (isLoaded) {
      resolve(window.google);
      return;
    }

    // Wird gerade geladen
    if (isLoading) {
      const checkLoaded = setInterval(() => {
        if (isLoaded) {
          clearInterval(checkLoaded);
          resolve(window.google);
        }
      }, 100);
      return;
    }

    isLoading = true;

    // API Key aus Runtime Config
    const apiKey = window.RUNTIME_CONFIG?.GOOGLE_MAPS_API_KEY;
    
    if (!apiKey) {
      reject(new Error('Google Maps API Key nicht in RUNTIME_CONFIG gefunden'));
      return;
    }

    // Script erstellen und laden
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      isLoaded = true;
      isLoading = false;
      resolve(window.google);
    };

    script.onerror = () => {
      isLoading = false;
      reject(new Error('Google Maps API konnte nicht geladen werden'));
    };

    document.head.appendChild(script);
  });
};